module.exports = "/_next/static/images/2b68fec08666d53a242e45c652b185c6-word-cup-xs-1x.png";